// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ICheckboxQuestion {
  /** Заголовок вопроса. Пример: «Чем риелтор может вам помочь?» **/
  title: string;
  /** Название поля, под которым будет храниться ответ. Например: «dealType» **/
  answerField: EAnswerField;
}

export enum EAnswerField {
  /** Чем риелтор может вам помочь? так-то это dealType, только странный **/
  'DealTypeEx' = 'dealTypeEx',
  /** Срок аренды **/
  'RentType' = 'rentType',
  /** Какую недвижимость хотите продать? **/
  'OfferType' = 'offerType',
  /** Уточните тип недвижимости **/
  'ObjectType' = 'objectType',
  /** Новостройка или вторичка? **/
  'FirstOrSecond' = 'firstOrSecond',
  /** Укажите количество комнат **/
  'RoomCount' = 'roomCount',
  /** Укажите общую площадь **/
  'Area' = 'area',
  /** Площадь от **/
  'AreaFrom' = 'areaFrom',
  /** Площадь до **/
  'AreaTo' = 'areaTo',
  /** Укажите адрес **/
  'Address' = 'address',
  /** Укажите предпочитаемую цену **/
  'Price' = 'price',
  /** Цена от **/
  'PriceFrom' = 'priceFrom',
  /** Цена до **/
  'PriceTo' = 'priceTo',
  /** Включая коммунальные платежи **/
  'IncludeCommunal' = 'includeCommunal',
  /** Включая эксплуатационные налоги **/
  'IncludeOperationalTaxes' = 'includeOperationalTaxes',
  /** Вы готовы снизить цену, в случае необходимости? **/
  'IsReadyToLower' = 'isReadyToLower',
  /** Объект в залоге у банка? **/
  'IsBankDeposit' = 'isBankDeposit',
  /** Вы получили квартиру в наследство? **/
  'IsInheritance' = 'isInheritance',
  /** В числе собственников есть несовершеннолетние? **/
  'IsMinorOwners' = 'isMinorOwners',
  /** Как срочно хотите совершить сделку? **/
  'DealPeriod' = 'dealPeriod',
  /** Как срочно хотите совершить сделку? (признак эксперимента) **/
  'DealPeriodExperimental' = 'dealPeriodExperimental',
  /** Вы уже разместили объявление? **/
  'IsHasOffer' = 'isHasOffer',
  /** Планируете брать кредит? **/
  'IsCredit' = 'isCredit',
  /** Как планируете покупать квартиру? **/
  'PurchaseMethod' = 'purchaseMethod',
  /** Уже есть одобрение ипотеки от банка? **/
  'MortgageBankApprove' = 'mortgageBankApprove',
  /** Уже накопили на первоначальный взнос? **/
  'IsMortgageInitialPayment' = 'isMortgageInitialPayment',
  /** Как вас зовут? **/
  'FullName' = 'fullName',
  /** Укажите номер мобильного телефона (с смс подтверждением) **/
  'Phone' = 'phone',
  /** Укажите номер мобильного телефона **/
  'PhoneVerify' = 'phoneVerify',
  /** Введите адрес электронной почты **/
  'Email' = 'email',
  /** Есть, что добавить? / Опишите вашу ситуацию **/
  'Comment' = 'comment',
  /** Поле для ответа отсутствует **/
  'Absent' = 'absent',
  /** Похоже, вы уже оценивали эту квартиру **/
  'HasEstimation' = 'hasEstimation',
  /** Системный AnswerField под наличие объявлений аренды **/
  'HasRentOfferData' = 'hasRentOfferData',
  /** Системный AnswerField под наличие объявлений продажи **/
  'HasSaleOfferData' = 'hasSaleOfferData',
  /** Вы агент по недвижимости? **/
  'IsAgent' = 'isAgent',
  /** Почему вас заинтересовала оценка?/Расскажите о себе, пожалуйста **/
  'ValuationReason' = 'valuationReason',
  /** Мы нашли объявления квартир с похожими параметрами. Вы хотите оценить квартиру из объявления? **/
  'OffersFound' = 'offersFound',
  /** Выберите объявление **/
  'Offer' = 'offer',
  /** Укажите тип дома **/
  'HouseMaterialType' = 'houseMaterialType',
  /** Год постройки дома **/
  'YearRelease' = 'yearRelease',
  /** Сколько этажей в доме? **/
  'FloorMax' = 'floorMax',
  /** На каком этаже расположена квартира? **/
  'Floor' = 'floor',
  /** Укажите высоту потолков **/
  'CeilingHeight' = 'ceilingHeight',
  /** Есть лоджия или балкон? **/
  'LoggiaOrBalcony' = 'loggiaOrBalcony',
  /** Куда выходят окна? **/
  'WindowsView' = 'windowsView',
  /** В квартире такая планировка? **/
  'Layout' = 'layout',
  /** Выберите текущий тип ремонта **/
  'Repair' = 'repair',
  /** Сколько лет ремонту? **/
  'RepairAge' = 'repairAge',
  /** Оцените стоимость ремонта. С учетом ремонта кухни, если он производился **/
  'RepairCost' = 'repairCost',
  /** Продаете вместе с техникой и мебелью? **/
  'WithAppliancesOrFurniture' = 'withAppliancesOrFurniture',
  /** Какая техника есть в квартире? **/
  'Appliances' = 'appliances',
  /** Комфорт **/
  'Comfort' = 'comfort',
  /** Оцените стоимость {техники и мебели} **/
  'AppliancesAndFurnitureCost' = 'appliancesAndFurnitureCost',
  /** В течение последних 10 лет в квартире производился капитальный ремонт? **/
  'Overhaul' = 'overhaul',
  /** Время до метро **/
  'TimeToMetro' = 'timeToMetro',
  /** Вопрос, где нужно выбрать инфраструктуру **/
  'Infrastructure' = 'infrastructure',
  /** Можно с детьми? **/
  'ChildrenAllowed' = 'childrenAllowed',
  /** Можно с животными? **/
  'PetsAllowed' = 'petsAllowed',
  /** Будете заключать договор аренды? **/
  'LeaseAgreement' = 'leaseAgreement',
  /** Хотите, чтобы с вами связался риелтор, для уточнения оценки? **/
  'WantRealtor' = 'wantRealtor',
  /** Уже выбрали проект дома под строительство? **/
  'IsProjectExists' = 'isProjectExists',
  /** Рассматриваете вариант покупки участка и постройки {дома}? **/
  'NeedLandForBuilding' = 'needLandForBuilding',
  /** Хотите подобрать проект дома и рассчитать его примерную стоимость? **/
  'NeedProject' = 'needProject',
  /** Вот что нашлось по вашему адресу **/
  'WhatIsFoundForAddress' = 'whatIsFoundForAddress',
  /** Вы знаете параметры квартиры и дома? **/
  'IsOfferParamsKnown' = 'isOfferParamsKnown',
  /** Форма с выбранными риэлторами отправлена **/
  'FormSentWithRealtors' = 'formSentWithRealtors',
  /** Доступнен ли выбор риэлторов? **/
  'IsAvailableRealtorChoice' = 'isAvailableRealtorChoice',
  /** Хотите сами выбрать риелторов для отправки заявки? **/
  'WantToChooseRealtor' = 'wantToChooseRealtor',
  /** Скрытый шаг для отправки формы **/
  'HiddenSubmitter' = 'hiddenSubmitter',
  /** Шаг с выбором риэлторов **/
  'RealtorListing' = 'realtorListing',
  /** Рассматриваете ли вы возможность начать сотрудничество с риэлтором? **/
  'CooperationStatus' = 'cooperationStatus',
  /** Идентификатор подписки на оценку **/
  'SubscriptionId' = 'subscriptionId',
  /** Валидация данных с объявления **/
  'IsOfferDataCorrect' = 'isOfferDataCorrect',
  /** Укажите расположение объекта **/
  'GeoInput' = 'geoInput',
  /** Сделаем точно **/
  'DoExactly' = 'doExactly',
  /** Какая у вас категория земель? **/
  'LandCategory' = 'landCategory',
  /** Какой статус участка? **/
  'LandStatus' = 'landStatus',
  /** На участке есть электричество? **/
  'ElectricityType' = 'electricityType',
  /** На участке есть газ? **/
  'SuburbanGasType' = 'suburbanGasType',
  /** На участке есть водоснабжение? **/
  'SuburbanWaterType' = 'suburbanWaterType',
  /** На участке есть канализация? **/
  'DrainageType' = 'drainageType',
  /** В доме можно жить постоянно? **/
  'HouseType' = 'houseType',
  /** Сколько в доме спален? **/
  'BedroomsCount' = 'bedroomsCount',
  /** Сколько в доме этажей? **/
  'FloorsCount' = 'floorsCount',
  /** Когда был построен дом? **/
  'BuildingYear' = 'buildingYear',
  /** Из чего сделаны стены? **/
  'MaterialType' = 'materialType',
  /** Как вы оцениваете состояние дома? **/
  'HouseCondition' = 'houseCondition',
  /** Где находится санузел? **/
  'WcLocationType' = 'wcLocationType',
  /** Как отапливается дом? **/
  'HeatingType' = 'heatingType',
  /** Что ещё есть в доме и на участке? **/
  'SuburbanConvenience' = 'suburbanConvenience',
}
